<template>
    <transition name="slide-fade">
        <div class="modal font-main" :class="{ 'open': open }" v-if="open">
            <div class="modal-content">
                <div class="bg-white w-full rounded-xl p-3 relative flex flex-col min-w-0 h-full">
                    <div class="text-center pb-5 font-medium text-14 text-a-gray-555555">
                        {{ title }}
                    </div>
                    <div class="flex-auto overflow-y-auto pb-4">
                        <PdpaContent :type="type" :file="file" :localeCode="localeCode" v-model:version="version"
                            @onError="onError($event)" />
                    </div>
                    <div class="flex justify-center pb-1 pt-4">
                        <div class="w-1/2">
                            <MainButton size="md-half" @click="clickAccept()">
                                {{ btnOk }}
                            </MainButton>
                        </div>
                    </div>

                    <div class="absolute top-2.5 right-2.5">
                        <button type="button" class="outline-none appearance-none bg-none" @click="clickClose()">
                            <img src="@/assets/icon/ic-close.svg" alt=""/>
                        </button>
                    </div>
                </div>
            </div>
        </div>
    </transition>

    <transition name="fade">
        <div class="modal-backdrop" v-if="open"></div>
    </transition>
</template>
<script>
// mixin
import ModalMixin from '@/mixin/ModalMixin';
import LocaleMixin from '@/mixin/LocaleMixin.js';
// component
import PdpaContent from '@/components/Authen/Pdpa/PdpaContent.vue';
import MainButton from '@/components/Button/MainButton.vue';

export default {
    name: 'PdpaModal',
    mixins: [LocaleMixin, ModalMixin],
    components: {
        PdpaContent,
        MainButton
    },
    props: {
        controller: { type: Object }
    },
    data: function () {
        return {
            open: false,

            title: '',
            type: '',
            file: '',
            version: '',
            busModal: null,
            btnOk: '',
        };
    },
    created: function () {
        this.busModal = this.controller.busModal;
    },
    mounted: function () {
        this.busModal.on('show', this.show);
        this.busModal.on('hide', this.hide);
    },
    methods: {
        //#region event
        onError: function (err) {
            this.hide();
            this.modal.alertModal
                .clearModal()
                .setMsg(err.message)
                .show();
        },
        //#endregion event
        show: function (config) {
            this.title = config.title;
            this.type = config.type || 'terms';
            this.file = config?.file ?? ''
            this.btnOk = config?.btnOk ?? 'ยอมรับ'

            document.body.classList.add('not-scroll');
            this.open = true;
        },
        hide: function () {
            document.body.classList.remove('not-scroll');
            this.open = false;
        },
        clickClose: function(){
            this.hide()
            this.controller.sendCallbackClose()
        },
        clickAccept: function(){
            this.hide()
            this.controller.sendCallbackAccept()
        }
    }
}
</script>
<style lang="scss" scoped>
@import "@/style/modal.scss";

.modal {
    @extend %modal;

    .modal-content {
        @apply w-full p-5 max-w-lg relative flex flex-col;
        max-height: 100vh;
        overflow: auto;

        &::-webkit-scrollbar {
            display: none;
        }
    }
}
</style>
